import styled from "styled-components";
import { Text } from "iparque-components";

export const TextContainer = styled.div`
  cursor: pointer;
  display: inline;
`;

export const UnderlinedText = styled(Text)`
  text-decoration: underline;

  :hover {
    opacity: 0.7;
  }
`;

export const ResendCodeContainer = styled.div`
  margin-top: 20px;
`;
